// import './App.css';
import { useEffect, useState } from "react";
import { FormControl, TextField, Button } from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import { updateAssessment, createAssessment } from "../services/api";

function AssessmentForm({ assessment, organizationId, onSaveSuccess }) {
  const [name, setName] = useState("");
  const [version, setVersion] = useState("");
  const [loading, setLoading] = useState(false);
  const classes = {};

  const refreshForm = () => {
    if (assessment.id) {
      setName(assessment.name);
      setVersion(assessment.version);
    } else {
      setName("");
      setVersion("");
    }
  };

  const saveChanges = () => {
    setLoading(true);
    assessment.name = name;
    assessment.version = version;
    if (assessment.id) {
      updateAssessment(assessment)
        .then((res) => {
          onSaveSuccess(res);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      assessment.organization_id = organizationId;
      createAssessment(assessment)
        .then((res) => {
          onSaveSuccess(res);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    refreshForm();
  }, []);

  const handleFieldChange = (setFunction) => {
    return (event) => {
      setFunction(event.target.value);
    };
  };

  return (
    <LoadingOverlay active={loading} spinner>
      <div class="bodyModal">
        <FormControl className={classes.formControl}>
          <TextField label="Name" value={name} onChange={handleFieldChange(setName)} className="inputForms" />
          <TextField label="Version" value={version} onChange={handleFieldChange(setVersion)} className="inputForms" />
        </FormControl>

        <div className="text-center">
          <Button variant="contained" color="primary" onClick={saveChanges} className="btn-main-limber mb-15 mt-15">
            Save
          </Button>
        </div>
      </div>
    </LoadingOverlay>
  );
}

export default AssessmentForm;
